import {
    IconEfficiency,
    IconEmpathy,
    IconOwnership,
    IconPositivity,
    IconTrust,
} from './components/icons';
import { Value } from './types';

export const VALUES: Value[] = [
    {
        classNameColor: 'bg-primary-green',
        description: (
            <>
                <p>
                    <strong>Trust</strong> • When you work at SwingDev, you can
                    trust that you are truly part of the team and that others
                    will have your back. You can also be sure that you, your
                    skills, and thoughts are trusted too. When someone on your
                    team says they are going to do something, you know it will
                    be done.
                </p>
                <p>
                    There are multiple ways to approach any issue, and you can
                    be confident that everyone at SwingDev has made their best
                    effort. This trust-based dynamic is what allows us to
                    accomplish tasks that are impossible for others.
                </p>
            </>
        ),
        icon: <IconTrust />,
        id: 1,
        name: 'Trust',
    },
    {
        classNameColor: 'bg-primary-pink',
        description: (
            <>
                <p>
                    <strong>Empathy</strong> • Effective collaboration is fueled
                    by empathy and understanding of the differences between us.
                    It allows us to take full advantage of everyone&apos;s
                    potential and become efficient coworkers, exceptional
                    developers, and reliable friends. You can be sure that your
                    team members always have good intentions, and they will
                    assume the same about you.
                </p>
                <p>
                    Empathy means your quirks, thoughts, and beliefs won’t be
                    judged. We believe being smart is not only about
                    productivity but also emotional intelligence, the ability to
                    establish empathetic connections, and building effective
                    relationships.
                </p>
            </>
        ),
        icon: <IconEmpathy />,
        id: 2,
        name: 'Empathy',
    },
    {
        classNameColor: 'bg-primary-orange',
        description: (
            <>
                <p>
                    <strong>Efficiency</strong> • Time is precious, so we want
                    to make sure we spend it wisely. Being efficient is about
                    working smart and using the best tools and techniques
                    available, not sticking to any dogmas.
                </p>

                <p>
                    It is about making educated decisions based on your
                    expertise and experience, not doing something that you know
                    doesn&apos;t make sense, just for the sake of doing it. It
                    means being proud of the end-result of your work and being
                    excited to put your name on it.
                </p>
            </>
        ),
        icon: <IconEfficiency />,
        id: 3,
        name: 'Efficiency',
    },
    {
        classNameColor: 'bg-primary-violet',
        description: (
            <>
                <p>
                    <strong>Ownership</strong> • Ownership is about noticing an
                    opportunity, taking the initiative, and making the most of
                    it. Challenge the status quo and keep in mind that small
                    improvements made every day can accumulate to great returns.
                </p>

                <p>
                    We believe that taking action is not someone else&apos;s
                    responsibility, and success is not just about the
                    end-result. It is about being happy with how your work was
                    done and how you interacted with other people. It&apos;s
                    just as important how things look behind the curtain and
                    under the hood.
                </p>
            </>
        ),
        icon: <IconOwnership />,
        id: 4,
        name: 'Ownership',
    },
    {
        classNameColor: 'bg-primary-yellow',
        description: (
            <>
                <p>
                    <strong>Positivity</strong> • Positivity does not imply that
                    we never have bad days or that we keep agreeing all the
                    time.
                </p>
                <p>
                    What it means is seeing the value in what you do, being
                    constructive and curious, and not letting the bad stuff
                    stick to you when it happens. It&apos;s appreciating people
                    and circumstances, being patient and inspiring, and simply
                    enjoying the journey.
                </p>
            </>
        ),
        icon: <IconPositivity />,
        id: 5,
        name: 'Positivity',
    },
];
